import { Position } from '__generated__/globalTypes';
import { joinFiltersWithOr } from 'lib/algolia';
import { StatsMode } from 'lib/playerSearchView';

const PositionByStatsMode = {
  [StatsMode.HITTING]: [
    Position.baseball_outfield,
    Position.baseball_first_base,
    Position.baseball_second_base,
    Position.baseball_third_base,
    Position.baseball_shortstop,
    Position.baseball_designated_hitter,
    Position.baseball_catcher,
  ],
  [StatsMode.PITCHING]: [
    Position.baseball_starting_pitcher,
    Position.baseball_relief_pitcher,
  ],
  [StatsMode.DEFAULT]: [],
};

export const useStatsModeFilterValue = (statsMode: StatsMode | false) => {
  const statsModeFilterValue = (() => {
    return joinFiltersWithOr(
      PositionByStatsMode[statsMode || StatsMode.DEFAULT].map(
        p => `position:${p}`
      )
    );
  })();

  return statsModeFilterValue;
};
